import React from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { deactivateSetting } from 'services/setting'

export default function useSetDeactivate(refetch: () => void) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: {
            id: string | undefined
            poolShip: number | undefined
        }) => {
            return deactivateSetting(payload)
        },
        onSuccess: (data) => {
            refetch()
            toast.success('با موفقیت انجام شد')
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })

    return { mutate }
}
